export function shouldFetchAvailableScans(
  bobAnalyseId: string,
  crisisStatus: 'active' | 'closed' | undefined
): boolean {
  return !!bobAnalyseId && crisisStatus === 'active'
}
